'use es6';

import tinymce from 'tinymce';
import { addControls } from './controls';
import { __HS_AUTO_COMPLETE } from '../constants/plugins';
import addEventListeners from './addEventListeners';
export function hsAutocompletePlugin(editor) {
  addEventListeners(editor);
  addControls(editor);
}
export const HS_AUTO_COMPLETE = __HS_AUTO_COMPLETE;
tinymce.PluginManager.add(HS_AUTO_COMPLETE, hsAutocompletePlugin);